
import log from '@/utils/log';
import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';

type ActivePageType = 'timetable' | 'rating' | 'notification' | 'status';

export default defineComponent({
  computed: {
    ...mapGetters(['userLoggedIn']),
    activePage() {
      const { path } = this.$route;
      if (/\/rating\/?.*$/.test(path)) {
        return 'rating';
      }
      if (/\/notification\/?.*$/.test(path)) {
        return 'notification';
      }
      if (
        /\/user\/?.*$/.test(path)
        || /\/login\/?.*$/.test(path)
        || /\/register\/?.*$/.test(path)
        || /\/forgot-password\/?.*$/.test(path)
        || /\/about\/?.*$/.test(path)
      ) {
        return 'status';
      }
      return 'timetable';
    },
  },
  methods: {
    handleClick(v: ActivePageType) {
      if (this.activePage === v) return;
      if (v === 'timetable') {
        this.$router.push({ name: 'Timetable' }).catch((e) => {
          log.error(e);
        });
      } else if (v === 'rating') {
        this.$router.push({ name: 'Rating' }).catch((e) => {
          log.error(e);
        });
      } else if (v === 'notification') {
        this.$router.push({ name: 'Notification' }).catch((e) => {
          log.error(e);
        });
      } else if (v === 'status') {
        this.$router.push({ name: this.userLoggedIn ? 'Me' : 'Login' }).catch((e) => {
          log.error(e);
        });
      }
    },
  },
});
